import * as M from "@discovery/prelude/lib/data/maybe";
export const readFloat = (i) => {
    const n = Number.parseFloat(i);
    return !Number.isNaN(n) ? M.of(n) : M.empty();
};
export const mod = (a, b) => ((a % b) + b) % b;

